export const collections = {
    groups_register: "groups-register",
    messages: "messages",
    users: "users",
    notif: "notif",
};

export const feilds = {
    group_id: "group_id",
    group_name: "group_name",
    group_members: "group_members",
    group_security: "group_security",
};
